export const config = {
  getTitleText: (_count, _itemLabel, record) => {
    const jobName = record?.jobTitle || record?.title || '';
    return jobName ? `Assign - ${jobName}` : 'Assign';
  },
  okText: 'Assign',
  width: 520,
  disabledUntilFilled: true,
  showAlreadyAssigned: true,
  fields: [
    {
      name: 'assignToUserId',
      label: 'Assign to',
      type: 'select',
      required: true,
      placeholder: 'Select a user',
      fetchOptionsKey: 'assignToUsers',
    },
    {
      name: 'candidateRate',
      label: 'Candidate Rate',
      type: 'candidate-rate',
    },
    {
      name: 'priority',
      label: 'Priority',
      type: 'priority-checkbox',
      checkboxLabel: 'Mark as High',
    },
  ],
};
